import { Map } from 'immutable';

/**
 * Custom messages for transpennine
 */

module.exports = new Map({
    'app.owner': 'TransPennine Express',
    'app.owner.toc': 'TPE',
    'app.owner.short': 'TransPennine Express',
    'app.owner.appName': 'TransPennine Express',
    'account.orders.refund.warning.manualRefund': 'For refund options please visit ',
    'account.nav.reservations': 'Reservations',

    'login.username': 'Email address',
    'customerdetails.email': 'Email address',
    'promotion.tocFamily.email.label': 'Email address',

    'ontrackapp.widget.title': 'Meet the {brand} App',

    'preference-centre.privacy-notice': '_',
    'preference-centre.privacy-notice.more': '_',
    'preference-centre.privacy-notice.extra': '_',

    'alertmessage.registration.failed.emailInUse': 'You already have an account with TransPennine Express. Please log in or use a different email address.',
    'account.register.smartcard.title': 'Get a<br /> <{global.smartcard}><br />with your account',
    'account.register.smartcard.title-mobile': 'Get a <{global.smartcard}><br />with your account',
    'booking.delivery.notAvailable.paper': 'Sorry. There are no collection or delivery options available for your order. This may be because you are attempting to buy a paper ticket within { todCollectionMinimumTime } of your time of departure. It may also be because you have bike reservations and the only available delivery method is eTicket.',
    'confirmation.sTicket.app.title': 'Your sTicket is available to download now in the TransPennine Express app.',

    'account.nav.smartcard.key-tickets': 'Smart Tickets',
    'account.nav.smartcard': 'Your <{global.smartcard}>',
    'account.nav.smartcard.replacement': '<{global.smartcard}> replacement',
    'account.nav.smartcard.tickets': 'Your Smart tickets',
    'account.nav.smartcard.journeyhistory': 'Your Smart journeys',
    'account.register.withoutSmartcard': 'Continue without registering for a <{global.smartcard}>',
    'account.register.withoutSmartcardAndKeygo': 'Continue without registering for a <{global.smartcard}> and <{global.keyGo}>',
    'account.register.withPaperTransfers.details': 'Transfer a current paper season to a <{global.smartcard}>',
    'account.register.steps.smartcard': '<{global.smartcard}>',
    'account.register.smartcard.labelLong': 'Get a <{global.smartcard}>',
    'account.register.smartcard.labelShort': 'Get a <{global.smartcard}>',
    'account.register.smartcard.title': 'Get a<br /> <{global.smartcard}><br />with your account',
    'account.register.smartcard.title-mobile': 'Get a <{global.smartcard}><br />with your account',
    'account.register.smartcard.body': 'Our <{global.smartcard}> is a smarter alternative to paper tickets, making it quicker and easier to buy a ticket.',
    'account.confirm.smartcardsignup': 'Get a <{global.smartcard}> with my account',
    'account.smartcardsignup.keygoSignUp': 'Get a <{global.smartcard}> and <{global.keyGo}> with my account',
    'account.smartcardsignup.readmore': 'Find out more about a <{global.smartcard}>',
    'account.smartcardsignup.details': 'A <{global.smartcard}> is an alternative to paper tickets that makes it quicker and easier to buy and use tickets.',
    'account.heading.smartcard.apply': 'Apply for a <{global.smartcard}>',
    'account.heading.smartcard.register': 'Register a <{global.smartcard}>',
    'account.heading.smartcard.status': '<{global.smartcard}> status',
    'account.heading.smartcard.tickets': '<{global.smartcard}> tickets',
    'account.heading.smartcard.journeyhistory': '<{global.smartcard}> - journey history',
    'account.heading.smartcard.incompletejourneys': '<{global.smartcard}> incomplete journeys',
    'account.heading.smartcard.activetickets': '<{global.smartcard}> tickets available to use',
    'account.heading.smartcard.pendingtickets': 'Tickets yet to be loaded to your <{global.smartcard}>',
    'booking.delivery.smartcardApply': 'Add to a new <{global.smartcard}> ',
    'booking.delivery.smartcardUnavailable': '<{global.smartcard}> unavailable',
    'booking.delivery.smartcardLoginOrRegister': 'Add to a new, or existing, <{global.smartcard}>',
    'delivery.smartcard.firstBenefit': 'A <{global.smartcard}> won’t wear out like paper tickets',
    'delivery.smartcard.secondBenefit': 'If you lose your <{global.smartcard}>, we’ll send you a replacement free of charge',
    'delivery.the-key-smartcard': 'Load to your <{global.smartcard}>(s)',
    'pageTitles.smartcard-tickets': '<{global.smartcard}> - tickets',
    'pageTitles.smartcard-history': '<{global.smartcard}> - journey history',
    'pageTitles.smartcard-replacement': '<{global.smartcard}> - replacement',
    'account.heading.smartcard.replacement': '<{global.smartcard}> - replacement',
    'booking.dates.errors.smartcardPeriodReturn': 'Only day returns are currently available on a <{global.smartcard}>. Please choose a return time on the same date as your outbound journey',
    'compensation.placeholder.smartcardNumber': '<{global.smartcard}> number',
    'account.smartcard.text.number': '<{global.smartcard}> number',
    'account.smartcard.text.capacity': '<{global.smartcard}> capacity',
    'account.smartcard.text.cardStatus': '<{global.smartcard}> status',
    'account.smartcard.text.cardExpiry': '<{global.smartcard}> expiry',
    'account.heading.smartcard.replacement.request': 'Request a new <{global.smartcard}>',
    'account.smartcard.text.replacement.cancellationWarning':
        '<p><strong>Please note:</strong> your existing smartcard will be cancelled as soon as your replacement request is submitted.</p>',
    'account.smartcard.text.replacement.success':
        'We are processing your request to replace your <{global.smartcard}>.',
    'account.smartcard.text.replacement.warning':
        'We are processing your request to replace your <{global.smartcard}>. Information shown here reflects your most recent <{global.smartcard}>. Some information may not be available at this time',
    'account.smartcard.text.replacement.linkText':
        'View the progress of your<{global.smartcard}> replacement',
    'account.smartcard.button.completeyourjourney':
        'Complete your <{global.smartcard}> journey',
    'account.smartcard.button.replacemycard': 'Request a new <{global.smartcard}>',
    'account.smartcard.text.noactivetickets': 'No <{global.smartcard}> tickets are currently active',
});



// WEBPACK FOOTER //
// ./src/messages/transpennine.js